import CONTENT_HEADER from "../plugins/content_header"
import GET_CATEGORIES from "../plugins/getCategories"
const [w] = [window]

const init = () => {
  // PC表示とSP表示のコンテンツヘッダーを共通化
  CONTENT_HEADER()
}

export default function INFORMATION () {
  $(w).on('load',function(){
    GET_CATEGORIES('.p-info_nav[data-plugin="getCategories"]',{
      itemClass: 'a',
      addAll: true
    })
  })
  document.addEventListener( 'DOMContentLoaded', init )
}